







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})

export default class ToggleSwitchComponent extends Vue {
  @Prop() public switchSize!: string; // default, small
  @Prop() public inactive?: boolean;
  @Prop() public startValue?: boolean;

  public checked = true;

  public created () {
    this.checked = this.startValue || false
  }

  public toggleSwitch () {
    this.$emit('toggle', this.checked)
  }
}
